export default __webpack_public_path__ + "static/media/Century Gothic.b194aa2b.ttf";